import * as moment from 'moment';

export class Usergroupusers {
    created	: moment.Moment;
    updated	: moment.Moment;
    userId	: number;
    usergroupId	: number;
}
